module.exports = __webpack_public_path__ + "static/CCTV_dome_camera-8150e39e627facc5666f8c295eb32e79.svg";